
//put this here because I needed it for validating the input, 
//and wasn't necessarily sure that it needed to go into the API.
export enum YesNo {
  Yes = "Yes",
  No = "No",
  Unknown = "Unknown",
}
